import { useParams, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { Box, Stack } from '@mui/material';
import { useUnit } from '../context/useUnits';
import { useTenant } from '../../../shared/context/TenantContext';
import { UnitForm } from '../components/UnitForm/UnitForm';
import { Button } from '../../../shared/components/ui/Button';
import { initialValues } from '../constants/unitConstants';
import { unitValidationSchema } from '../validations/unitValidationSchema';

export default function UnitFormPage() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const { selectedTenant } = useTenant();
  const navigate = useNavigate();

  const {
    unitData,
    isDataLoading,
    createUnit,
    updateUnit,
    isSubmitting,
    error,
    setError
  } = useUnit();

  async function handleSubmit(formData: any) {
    try {
      if (isEdit && id) {
        await updateUnit(id, {
          number: formData.number,
          description: formData.description,
          sector_id: formData.sector_id,
        });
        navigate(`/units/${id}`);
      } else {
        await createUnit({
          ...formData,
          tenant_id: selectedTenant.trim(),
        });
        navigate('/units');
      }
    } catch (error) {
      setError('Erro ao salvar unidade');
    }
  }

  function handleCancel() {
    navigate(-1);
  }

  if (isEdit && isDataLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        Carregando...
      </Box>
    );
  }

  const formInitialValues = isEdit && unitData
    ? { ...initialValues, ...unitData, tenant_id: unitData.tenant?.id, sector_id: unitData.sector?.id }
    : initialValues;

  return (
    <Box sx={{ p: 2 }}>
      {error && (
        <Box sx={{ mb: 2, p: 2, bgcolor: 'error.light', color: 'error.contrastText', borderRadius: 1 }}>
          {error}
        </Box>
      )}

      <Formik
        initialValues={formInitialValues}
        validationSchema={unitValidationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ isValid, dirty }) => (
          <Form>
            <UnitForm
              mode={isEdit ? 'edit' : 'create'}
              loading={isSubmitting}
            />

            <Box sx={{ mt: 3, p: 2 }}>
              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  disabled={isSubmitting}
                >
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={isSubmitting || !isValid || !dirty}
                  loading={isSubmitting}
                >
                  {isEdit ? 'Salvar' : 'Criar'}
                </Button>
              </Stack>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}